


<ng-container>
  <ng-container >
    <app-bread-crumbs  [lang]="lang" [routes]="nameRouting"></app-bread-crumbs>
  </ng-container>
  <!-- <h3 class="lable mx-3 my-3">{{ "productDetails.allBrands" | translate }}</h3> -->
  <div class="container mt-4">
    <div class="row brands-grid">
      <div class="p-0" style="cursor: pointer"  style="margin-bottom:10px ;" 
      *ngFor="let brand of brandsList | paginate
      : {
            itemsPerPage: 20,
            currentPage: currentPage,
            totalItems: totalPage
        };
let i = index"> 
        <a
            style="margin: 0px auto !important"
            class="brand-item"
            (click)="redirectToBrand(brand)"
        >
            <div class="imgContainer mx-2"
            [ngClass]="{'radius-50' : brandTypeData?.isSqure == 'round' }">
                <img  loading="lazy" 
                [ngClass]="{'radius-50' : brandTypeData?.isSqure == 'round' }"
                    [src]="brand.image"
                       [alt]="brand.image"
                    onError="this.src='./assets/images/placeholder200.jpg';"
                    default="./assets/images/placeholder200.jpg"
                    style="
                        position: relative;
                        top: 0px;
                        left: 0px;
                        margin-left: 0px;
                        margin-right: 0px;
                        object-fit: contain;
                    "
                />
                <h3 *ngIf="environmentVariables?.ENABLE_SHOW_BRAND_NAME"
                    class="text-center" style="color: var(--secoundry-color);" >
                  {{ lang == "en" ? brand.name : brand.name_ar }}
                </h3>
            </div>
          
        </a>
    </div>
    </div>
  </div>


  <div class="pagination">
    <pagination-controls
        class="product-pagination"
        (pageChange)="onPageChanged($event)"
        nextLabel="{{ 'button.next' | translate }}"
        previousLabel="{{ 'button.previous' | translate }}"
    >
    </pagination-controls>
</div>
</ng-container>

